import React from 'react';
import './Partners.css';

interface Partner {
  name: string;
  website: string;
}

const partners: Partner[] = [
  { name: 'Alcedo', website: '' },
  { name: 'Cofco International Romania', website: 'https://partner2.com' },
  { name: 'Ameropa Grains', website: 'https://partner3.com' },
  { name: 'Vitall', website: 'https://partner4.com' },
  { name: 'Cargill', website: 'https://partner5.com' },
];

const OurPartners: React.FC = () => {
  return (
    <section className="our-partners">
      <h2>Partenerii noștri</h2>
      <div className="partners-container">
        {partners.map((partner, index) => (
          <button
            key={index}
            rel="noopener noreferrer"
            className="partner-card"
          >
            <div className="partner-name">{partner.name}</div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default OurPartners;
